import { Plugin } from 'prosemirror-state';
import ImageResize from 'tiptap-extension-resize-image';
// import Image from '@tiptap/extension-image';

export default ImageResize.extend({
  name: "image-ext",
  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handleDOMEvents: {
            drop(view, event) {
              const hasFiles =
                event.dataTransfer &&
                event.dataTransfer.files &&
                event.dataTransfer.files.length

              if (!hasFiles) {
                return
              }

              const images = Array.from(event.dataTransfer.files).filter(file =>
                /image/i.test(file.type)
              )

              if (images.length === 0) {
                return
              }

              event.preventDefault()

              const { schema } = view.state
              console.log(schema.nodes)
              const coordinates = view.posAtCoords({
                left: event.clientX,
                top: event.clientY
              })

              images.forEach(image => {
                const reader = new FileReader()

                reader.onload = readerEvent => {
                  // const node = schema.nodes.image.create({
                  const node = schema.nodes['image-ext'].create({
                    src: readerEvent.target?.result
                  })
                  if (coordinates) {
                    const transaction = view.state.tr.insert(
                      coordinates.pos,
                      node
                    )
                    view.dispatch(transaction)
                  }
                }
                reader.readAsDataURL(image)
              })
            },
            paste(view, event) {
              const hasFiles =
                event.clipboardData &&
                event.clipboardData.files &&
                event.clipboardData.files.length

              if (!hasFiles) {
                return
              }

              const images = Array.from(
                event.clipboardData.files
              ).filter(file => /image/i.test(file.type))

              if (images.length === 0) {
                return
              }

              event.preventDefault()

              const { schema } = view.state

              images.forEach(image => {
                const reader = new FileReader()

                reader.onload = readerEvent => {
                  // const node = schema.nodes.image.create({
                  const node = schema.nodes['image-ext'].create({
                    src: readerEvent.target?.result
                  })
                  const transaction = view.state.tr.replaceSelectionWith(node)
                  view.dispatch(transaction)
                }
                reader.readAsDataURL(image)
              })
            }
          }
        }
      })
    ]
  },
  // addExtensions() {
  //   return [ImageResize];
  // }
})